import { render, staticRenderFns } from "./DemoVideos.vue?vue&type=template&id=1f7733be&"
import script from "./DemoVideos.vue?vue&type=script&lang=js&"
export * from "./DemoVideos.vue?vue&type=script&lang=js&"
import style0 from "./DemoVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports